export default (graph) => {
    window.printPoint = () => {
        let obj = {};
        // d3.selectAll('.kg-force-node-wrap').each(d => {
        //     obj[d.id] = {
        //         x: d.x,
        //         y: d.y
        //     };
        // });
        // console.log(JSON.stringify(obj));
        graph.nodesGroup.each(d => {
            obj[d.id_origin] = {
                x: d.x,
                y: d.y
            };
        });

        let objStr = JSON.stringify(obj);
        console.log(objStr);
        return objStr;
    };
    window.printPointAndCopy = () => {
        copy(window.printPoint(graph));
    };
    window.fixedGraph = () => {
        graph.data.nodes.forEach((d) => {
            d.fx = d.x;
            d.fy = d.y;
        })
    };
};

// window.d3 = d3;
// window.printPoint = () => {
//     var obj = {};
//     d3.selectAll('.kg-force-node-wrap').each(d => {
//         obj[d.id_origin] = {
//             x: d.x,
//             y: d.y
//         };
//     });
//     console.log(JSON.stringify(obj));
//     this.nodesGroup.each(d => {
//         obj[d.id_origin] = {
//             x: d.x,
//             y: d.y
//         };
//     });
//     console.log(JSON.stringify(obj));
// }
// console.log(this.tickNum);
